import {blue, orange} from '@mui/material/colors';

const cryptoData = {
  coinGraphData: {
    bitcoin: {
      yearlyData: [
        {month: 'Jan', amount: 6000},
        {month: 'Feb', amount: 4800},
        {month: 'Mar', amount: 6500},
        {month: 'Apr', amount: 6000},
        {month: 'May', amount: 7800},
        {month: 'Jun', amount: 9000},
        {month: 'Jul', amount: 6000},
        {month: 'Aug', amount: 7000},
        {month: 'Sep', amount: 3700},
        {month: 'Oct', amount: 7800},
        {month: 'Nov', amount: 5800},
        {month: 'Dec', amount: 6500},
      ],
      monthlyData: [
        {date: '1', amount: 6000},
        {date: '2', amount: 4800},
        {date: '3', amount: 6500},
        {date: '4', amount: 6000},
        {date: '5', amount: 7800},
        {date: '6', amount: 9000},
        {date: '7', amount: 6000},
        {date: '8', amount: 7000},
        {date: '9', amount: 3700},
        {date: '10', amount: 7800},
        {date: '11', amount: 5800},
        {date: '12', amount: 6500},
        {date: '13', amount: 7200},
        {date: '14', amount: 6500},
        {date: '15', amount: 2344},
        {date: '16', amount: 4243},
        {date: '17', amount: 5343},
        {date: '18', amount: 2435},
        {date: '19', amount: 4322},
        {date: '20', amount: 2545},
        {date: '21', amount: 3234},
        {date: '22', amount: 4233},
        {date: '23', amount: 2444},
        {date: '24', amount: 6543},
        {date: '25', amount: 4223},
        {date: '26', amount: 4323},
        {date: '27', amount: 2345},
        {date: '28', amount: 2345},
        {date: '29', amount: 5676},
        {date: '30', amount: 2345},
      ],
      weeklyData: [
        {day: 'Monday', amount: 6000},
        {day: 'Tuesday', amount: 4800},
        {day: 'Wednesday', amount: 6500},
        {day: 'Thrusday', amount: 6000},
        {day: 'Friday', amount: 7800},
        {day: 'Saturday', amount: 9000},
        {day: 'Sunday', amount: 6000},
      ],
      dailyData: [
        {time: '00:00', amount: 2444},
        {time: '01:00', amount: 6000},
        {time: '02:00', amount: 4800},
        {time: '03:00', amount: 6500},
        {time: '04:00', amount: 6000},
        {time: '05:00', amount: 7800},
        {time: '06:00', amount: 9000},
        {time: '07:00', amount: 6000},
        {time: '08:00', amount: 7000},
        {time: '09:00', amount: 3700},
        {time: '10:00', amount: 7800},
        {time: '11:00', amount: 5800},
        {time: '12:00', amount: 6500},
        {time: '13:00', amount: 7200},
        {time: '14:00', amount: 6500},
        {time: '15:00', amount: 2344},
        {time: '16:00', amount: 4243},
        {time: '17:00', amount: 5343},
        {time: '18:00', amount: 2435},
        {time: '19:00', amount: 4322},
        {time: '20:00', amount: 2545},
        {time: '21:00', amount: 3234},
        {time: '22:00', amount: 4233},
        {time: '23:00', amount: 2444},
      ],
    },
    litecoin: {
      yearlyData: [
        {month: 'Jan', amount: 5600},
        {month: 'Feb', amount: 4400},
        {month: 'Mar', amount: 6000},
        {month: 'Apr', amount: 4500},
        {month: 'May', amount: 7000},
        {month: 'Jun', amount: 6400},
        {month: 'Jul', amount: 8000},
        {month: 'Aug', amount: 6500},
        {month: 'Sep', amount: 7000},
        {month: 'Oct', amount: 5800},
        {month: 'Nov', amount: 6200},
        {month: 'Dec', amount: 5000},
      ],
      monthlyData: [
        {date: '1', amount: 5600},
        {date: '2', amount: 7000},
        {date: '3', amount: 6400},
        {date: '4', amount: 4500},
        {date: '5', amount: 5500},
        {date: '6', amount: 5900},
        {date: '7', amount: 7500},
        {date: '8', amount: 6500},
        {date: '9', amount: 5400},
        {date: '10', amount: 5000},
        {date: '11', amount: 4400},
        {date: '12', amount: 4900},
        {date: '13', amount: 5500},
        {date: '14', amount: 6300},
        {date: '15', amount: 3944},
        {date: '16', amount: 4243},
        {date: '17', amount: 5043},
        {date: '18', amount: 6935},
        {date: '19', amount: 5622},
        {date: '20', amount: 7645},
        {date: '21', amount: 4034},
        {date: '22', amount: 5633},
        {date: '23', amount: 3944},
        {date: '24', amount: 4543},
        {date: '25', amount: 4023},
        {date: '26', amount: 3623},
        {date: '27', amount: 5045},
        {date: '28', amount: 3645},
        {date: '29', amount: 4576},
        {date: '30', amount: 2945},
      ],
      weeklyData: [
        {day: 'Monday', amount: 6500},
        {day: 'Tuesday', amount: 5200},
        {day: 'Wednesday', amount: 7800},
        {day: 'Thrusday', amount: 3900},
        {day: 'Friday', amount: 5200},
        {day: 'Saturday', amount: 2600},
        {day: 'Sunday', amount: 7800},
      ],
      dailyData: [
        {time: '00:00', amount: 4500},
        {time: '01:00', amount: 6000},
        {time: '02:00', amount: 3500},
        {time: '03:00', amount: 4300},
        {time: '04:00', amount: 5500},
        {time: '05:00', amount: 6300},
        {time: '06:00', amount: 7000},
        {time: '07:00', amount: 6000},
        {time: '08:00', amount: 5200},
        {time: '09:00', amount: 3900},
        {time: '10:00', amount: 4600},
        {time: '11:00', amount: 4000},
        {time: '12:00', amount: 4800},
        {time: '13:00', amount: 6400},
        {time: '14:00', amount: 5200},
        {time: '15:00', amount: 3944},
        {time: '16:00', amount: 2543},
        {time: '17:00', amount: 4043},
        {time: '18:00', amount: 4735},
        {time: '19:00', amount: 3822},
        {time: '20:00', amount: 5245},
        {time: '21:00', amount: 6534},
        {time: '22:00', amount: 5533},
        {time: '23:00', amount: 5044},
      ],
    },
    ripple: {
      yearlyData: [
        {month: 'Jan', amount: 7600},
        {month: 'Feb', amount: 6200},
        {month: 'Mar', amount: 6800},
        {month: 'Apr', amount: 5000},
        {month: 'May', amount: 4200},
        {month: 'Jun', amount: 5600},
        {month: 'Jul', amount: 6800},
        {month: 'Aug', amount: 8100},
        {month: 'Sep', amount: 5700},
        {month: 'Oct', amount: 4500},
        {month: 'Nov', amount: 3700},
        {month: 'Dec', amount: 4700},
      ],
      monthlyData: [
        {date: '1', amount: 4300},
        {date: '2', amount: 3600},
        {date: '3', amount: 4500},
        {date: '4', amount: 5200},
        {date: '5', amount: 4800},
        {date: '6', amount: 5600},
        {date: '7', amount: 6700},
        {date: '8', amount: 5400},
        {date: '9', amount: 5000},
        {date: '10', amount: 6300},
        {date: '11', amount: 6700},
        {date: '12', amount: 7800},
        {date: '13', amount: 7300},
        {date: '14', amount: 6200},
        {date: '15', amount: 4644},
        {date: '16', amount: 5043},
        {date: '17', amount: 4243},
        {date: '18', amount: 4635},
        {date: '19', amount: 3222},
        {date: '20', amount: 4145},
        {date: '21', amount: 3734},
        {date: '22', amount: 4233},
        {date: '23', amount: 3144},
        {date: '24', amount: 3543},
        {date: '25', amount: 3023},
        {date: '26', amount: 4023},
        {date: '27', amount: 4245},
        {date: '28', amount: 3145},
        {date: '29', amount: 3576},
        {date: '30', amount: 2345},
      ],
      weeklyData: [
        {day: 'Monday', amount: 3400},
        {day: 'Tuesday', amount: 4800},
        {day: 'Wednesday', amount: 3700},
        {day: 'Thrusday', amount: 5600},
        {day: 'Friday', amount: 5100},
        {day: 'Saturday', amount: 7200},
        {day: 'Sunday', amount: 6300},
      ],
      dailyData: [
        {time: '00:00', amount: 2600},
        {time: '01:00', amount: 3300},
        {time: '02:00', amount: 2800},
        {time: '03:00', amount: 3200},
        {time: '04:00', amount: 4000},
        {time: '05:00', amount: 3400},
        {time: '06:00', amount: 3100},
        {time: '07:00', amount: 4500},
        {time: '08:00', amount: 4900},
        {time: '09:00', amount: 4200},
        {time: '10:00', amount: 5300},
        {time: '11:00', amount: 5900},
        {time: '12:00', amount: 4800},
        {time: '13:00', amount: 6800},
        {time: '14:00', amount: 6100},
        {time: '15:00', amount: 7844},
        {time: '16:00', amount: 7143},
        {time: '17:00', amount: 4043},
        {time: '18:00', amount: 4835},
        {time: '19:00', amount: 4322},
        {time: '20:00', amount: 3645},
        {time: '21:00', amount: 4934},
        {time: '22:00', amount: 5933},
        {time: '23:00', amount: 3944},
      ],
    },
  },
  buySell: {
    buyData: {
      value: '122',
      price: '$7223.9',
      amount: '$87323.8',
    },
    sellData: {
      value: '34',
      price: '$723.9',
      amount: '$7632.8',
    },
  },
  coinsData: {
    bitcoin: {
      price: '7289.75',
      increment: 0.8,
    },
    etherium: {
      price: '170.720',
      increment: 0.76,
    },
    liteCoin: {
      price: '65.1200',
      increment: -0.4,
    },
    ripple: {
      price: '0.2544',
      increment: 0.08,
    },
  },
  marketGraphData: [
    {month: 'Jan', medium: 3000, low: 4000, high: 0, amt: 2400},
    {month: 'Feb', medium: 1000, low: 4000, high: 0, amt: 2210},
    {month: 'Mar', medium: 4000, low: 4000, high: 1200, amt: 2290},
    {month: 'Apr', medium: 3700, low: 4000, high: 0, amt: 2000},
    {month: 'May', medium: 1890, low: 4000, high: 0, amt: 2181},
    {month: 'Jun', medium: 0, low: 1800, high: 0, amt: 2400},
    {month: 'Jul', medium: 0, low: 3500, high: 0, amt: 2400},
    {month: 'Aug', medium: 4000, low: 4000, high: 0, amt: 2400},
  ],
  newsData: [
    {
      id: 1,
      news: 'JAKARTA, (20/2) - Kementerian Kelautan dan Perikanan (KKP) bersama dengan Dewan...',
      created: '16 min',
      image: 'https://portalkkp.coofis.com/media/news_kkp/KKP_Bersama_DPR_RI_Kembangkan_Budidaya_Ikan_Air_Tawar_di_Lombok_Tengah_1_copy_1.jpeg',
      by: 'DITJEN PERIKANAN BUDIDAYA',
      title_news:'KKP Bersama DPR RI Kembangkan Budidaya Ikan Air Tawar di Lombok Tengah',
      description_news:"JAKARTA, (20/2) - Kementerian Kelautan dan Perikanan (KKP) bersama dengan Dewan Perwakilan Rakyat (DPR) RI Komisi IV tengah mengembangkan budidaya ikan air tawar di Lombok Tengah. Upaya ini sejalan dengan peningkatan produksi perikanan budidaya guna menopang ketahanan pangan dan ekonomi daerah maupun nasional.<br><br>Direktur Jenderal Perikanan Budidaya, Tb Haeru Rahayu, mengatakan, untuk menopang ketahanan pangan dan menggerakan ekonomi di daerah, KKP dalam hal ini Direktorat Jenderal Perikanan Budidaya (DJPB) terus melakukan akselerasi guna meningkatan produksi perikanan di daerah.  Untuk itu, KKP mendorong daerah-daerah potensial seperti Lombok Tengah ini untuk dikembangkan budidaya ikan air tawarnya.<br><br>“Terdapat perputaran uang yang besar hingga mencapai triliunan rupiah di Desa Bunkate Kecamatan Jonggat Kabupaten Lombok Tengah. Tentunya ini merupakan capaian yang luar biasa untuk satu desa”, ungkap Dirjen yang akrab disapa Tebe ini.<br><br>FAO memprediksi kebutuhan protein dunia akan meningkat hingga 70%, pasalnya populasi dunia diperkirakan akan tumbuh lebih dari sepertiga hingga tahun 2050.<br><br>Memiliki 17.504 pulau, Indonesia merupakan negara kepulauan terbesar di dunia. Dengan 6,4 juta kilometer persegi wilayah perairan dan zona ekonomi eksklusif, serta sumberdaya laut melimpah yang merupakan sumber pangan protein hewani dan peluang pekerjaan bagi jutaan masyarakat pesisir."
    },
    {
      id: 2,
      news: 'BITUNG (14/2) - Kementerian Kelautan dan Perikanan (KKP) melalui Badan Riset dan Sumber Daya...',
      created: '45 min',
      image: 'https://portalkkp.coofis.com/media/news_kkp/KKP_Latih_Nelayan_untuk_Kawal_Blue_Economy_1.jpeg',
      by: 'HUMAS BRSDM',
      title_news:'KKP Latih Nelayan untuk Kawal Blue Economy',
      description_news:'BITUNG (14/2) - Kementerian Kelautan dan Perikanan (KKP) melalui Badan Riset dan Sumber Daya Manusia Kelautan dan Perikanan (BRSDM) terus melakukan pelatihan untuk meningkatkan kapasitas masyarakat dalam penanganan dan pengolahan ikan. Pelatihan-pelatihan tersebut juga dimaksudkan sebagai upaya mengawal program-program blue economy yang saat ini sedang menjadi prioritas KKP. <br><br>Kepala Pusat Pelatihan dan Penyuluhan Kelautan dan Perikanan (Puslatluh KP) BRSDM Lilly Aprilya Pregiwati mengatakan, pada 7 Februari 2023 pihaknya menggelar dua pelatihan sekaligus, yaitu Pelatihan Pembuatan Fish Roll dan Pelatihan Penanganan Hasil Tangkapan secara daring. Total terdapat 1.293 peserta yang mengikuti kedua pelatihan tersebut, terdiri dari 546 orang pada Pelatihan Penanganan Hasil Tangkapan dan 747 orang pada Pelatihan Pembuatan Fish Roll. Pelatihan ini difasilitasi oleh Balai Pelatihan dan Penyuluhan Perikanan (BPPP) Bitung, Sulawesi Utara. <br><br>Pelatihan tersebut juga menyasar khusus masyarakat perikanan yang berasal dari Desa Sei Pancang, Kabupaten Nunukan, Provinsi Kalimantan Utara dan Desa Kema III, Kabupaten Minahasa Utara, Provinsi Sulawesi Utara. Hal itu berkaitan dengan dukungan untuk Kampung Nelayan Maju yang berada di Desa Kema III. <br><br> Seluruh peserta menyambut baik kedua pelatihan tersebut. Hal itu diungkapkan Novita, peserta dari Desa Kema III, Kabupaten Minahasa Utara, dan Fathan, peserta dari Kabupaten Nunukan. <br><br>“Saya mewakili kelompok Novita mengucapkan terima kasih banyak kepada Puslatluh KP dan BPPP Bitung yang sudah mengadakan Pelatihan Pembuatan Fish Roll sehingga dapat menambah keterampilan kami semua. Saya berharap pelatihan seperti ini dapat diadakan kembali di waktu yang akan datang,” jelas Novita.'
    },
    {
      id: 3,
      news: 'JAKARTA, (10/2) – Kementerian Kelautan dan Perikanan (KKP) berkolaborasi dengan Seychelles dalam...',
      created: '1 jam',
      image: 'https://portalkkp.coofis.com/media/news_kkp/KKP-Seychelles_1.jpeg',
      by: 'HUMAS BRSDM',
      title_news:'KKP-Seychelles Kolaborasi Tingkatkan Kualitas SDM untuk Sukseskan Implementasi Ekonomi Biru',
      description_news:'JAKARTA, (10/2) – Kementerian Kelautan dan Perikanan (KKP) berkolaborasi dengan Seychelles dalam peningkatan pengetahuan dan keilmuan mengenai blue carbon untuk mendukung Blue Economy. <br><br>Kolaborasi tersebut berupa pelaksanaan kegiatan Training on Trainers (ToT) on the Blue Economy Program yang berlangsung secara hybrid diikuti 700 peserta, Kamis,(9/2). Hadir tiga narasumber dari United Kingdom Blue Economy Solution, yakni Ralph Chami, Jonathan Turner, dan Andrew Hamflett.<br><br> “Kegiatan ini merupakan rangkaian kolaborasi antara KKP dan Seychelles yang sudah diinisiai sejak tahun 2021, dalam rangka penajaman blue economy serta memberikan tambahan pengetahuan dan keilmuan mengenai Blue Carbon, Blue Bond, dan Marine Protected Area, serta pentingnya pengelolaan sumber daya kelautan dan perikanan yang berkelanjutan, untuk menjamin keberlanjutan ekosistem perikanan di Indonesia, mendorong distribusi ekonomi yang merata di wilayah pesisir, meningkatkan daya saing produk perikanan di pasar global, hingga sebagai solusi persoalan iklim dengan terjaganya ekosistem blue carbon ,” papar Nyoman pada kegiatan tersebut.'
    },
  ],
  newsExtData: [
    {
      "title": "Jumlah pengangguran awal 2023 menurun",
      "description": "Badan Pusat Statistik (BPS) melaporkan jumlah pengangguran di Indonesia pada Februari 2023 mengalami penurunan dibandingkan dengan kondisi Agustus 2022, dan ini tidak lepas dari serangkaian upaya yang dilakukan pemerintah.",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/09/20230509jumlah-pengangguran-menurun.jpg\" align=\"left\" border=\"0\" />Badan Pusat Statistik (BPS) melaporkan jumlah pengangguran di Indonesia pada Februari 2023 mengalami penurunan dibandingkan dengan kondisi Agustus 2022, dan ini tidak lepas dari serangkaian upaya yang dilakukan pemerintah.",
      "date": "2023-05-09T00:01:44.000Z",
      "pubdate": "2023-05-09T00:01:44.000Z",
      "link": "https://www.antaranews.com/infografik/3528093/jumlah-pengangguran-awal-2023-menurun"
    },
    {
      "title": "BMKG: Indonesia diselimuti cuaca berawan pada Selasa",
      "description": "Badan Meteorologi, Klimatologi, dan Geofisika (BMKG) memprakirakan sebagian besar daerah di Indonesia berpotensi diselimuti cuaca berawan pada Selasa siang.\n\nBerdasarkan data di laman resmi BMKG di Jakarta, Selasa, daerah yang ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/04/08/BML-KG.jpg\" align=\"left\" border=\"0\" />Badan Meteorologi, Klimatologi, dan Geofisika (BMKG) memprakirakan sebagian besar daerah di Indonesia berpotensi diselimuti cuaca berawan pada Selasa siang.\n\nBerdasarkan data di laman resmi BMKG di Jakarta, Selasa, daerah yang ...",
      "date": "2023-05-08T23:32:12.000Z",
      "pubdate": "2023-05-08T23:32:12.000Z",
      "link": "https://www.antaranews.com/berita/3528072/bmkg-indonesia-diselimuti-cuaca-berawan-pada-selasa"
    },
    {
      "title": "Fulham kalahkan Leicester City 5-3",
      "description": "Pemain&nbsp;Fulham&nbsp;Tom Cairney&nbsp;mencetak gol keempat melewati penjagaan kiper Leicester City&nbsp;Daniel Iversen&nbsp;pada pertandingan Liga Inggris di&nbsp;Craven Cottage, London, Inggris ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/08/2023-05-08T160652Z_245519715_UP1EJ5818RFDU_RTRMADP_3_SOCCER-ENGLAND-FUL-LEI-REPORT.jpg\" align=\"left\" border=\"0\" />Pemain&nbsp;Fulham&nbsp;Tom Cairney&nbsp;mencetak gol keempat melewati penjagaan kiper Leicester City&nbsp;Daniel Iversen&nbsp;pada pertandingan Liga Inggris di&nbsp;Craven Cottage, London, Inggris ...",
      "date": "2023-05-08T16:45:19.000Z",
      "pubdate": "2023-05-08T16:45:19.000Z",
      "link": "https://www.antaranews.com/foto/3527934/fulham-kalahkan-leicester-city-5-3"
    },
    {
      "title": "Klasemen medali SEA Games :  Indonesia disalip Vietnam dan Thailand",
      "description": "Indonesia harus rela turun ke urutan keempat klasemen sementara perolehan medali SEA Games 2023, Senin malam, setelah Vietnam dan Thailand menggeser tempat kontingen Merah Putih untuk menduduki masing-masing posisi kedua dan ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/09/antarafoto-zohri-perunggu-sea-games-080523-adm-3.jpg\" align=\"left\" border=\"0\" />Indonesia harus rela turun ke urutan keempat klasemen sementara perolehan medali SEA Games 2023, Senin malam, setelah Vietnam dan Thailand menggeser tempat kontingen Merah Putih untuk menduduki masing-masing posisi kedua dan ...",
      "date": "2023-05-08T16:14:22.000Z",
      "pubdate": "2023-05-08T16:14:22.000Z",
      "link": "https://www.antaranews.com/berita/3527880/klasemen-medali-sea-games-indonesia-disalip-vietnam-dan-thailand"
    },
    {
      "title": "Pemerintah optimalkan APBN jaga momentum percepatan ekonomi RI",
      "description": "Pemerintah masih akan mengoptimalkan peran Anggaran Pendapatan dan Belanja Negara (APBN) sebagai peredam gejolak global untuk menjaga momentum percepatan pertumbuhan ekonomi nasional.\n\n&quot;Di tengah dinamika perekonomian ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/08/mulyani-2ab.jpg\" align=\"left\" border=\"0\" />Pemerintah masih akan mengoptimalkan peran Anggaran Pendapatan dan Belanja Negara (APBN) sebagai peredam gejolak global untuk menjaga momentum percepatan pertumbuhan ekonomi nasional.\n\n&quot;Di tengah dinamika perekonomian ...",
      "date": "2023-05-08T14:40:21.000Z",
      "pubdate": "2023-05-08T14:40:21.000Z",
      "link": "https://www.antaranews.com/berita/3527652/pemerintah-optimalkan-apbn-jaga-momentum-percepatan-ekonomi-ri"
    },
    {
      "title": "Timnas voli putra Indonesia rebut emas SEA Games usai bekuk Kamboja",
      "description": "Timnas bola voli putra Indonesia sukses memenuhi target dengan merebut medali emas SEA Games 2023 usai membekuk tuan rumah Kamboja di Olympic Indoor Stadium, Phnom Penh, Senin dengan skor meyakinkan 3-0 (25-21, 25-10, ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/08/Medali-Emas-Voli-Putra-Sea-Games-080523-5.jpg\" align=\"left\" border=\"0\" />Timnas bola voli putra Indonesia sukses memenuhi target dengan merebut medali emas SEA Games 2023 usai membekuk tuan rumah Kamboja di Olympic Indoor Stadium, Phnom Penh, Senin dengan skor meyakinkan 3-0 (25-21, 25-10, ...",
      "date": "2023-05-08T14:30:03.000Z",
      "pubdate": "2023-05-08T14:30:03.000Z",
      "link": "https://www.antaranews.com/berita/3527628/timnas-voli-putra-indonesia-rebut-emas-sea-games-usai-bekuk-kamboja"
    },
    {
      "title": "BI ungkap strategi menjaga stabilitas rupiah di tengah gejolak ekonomi",
      "description": "Gubernur Bank Indonesia (BI) Perry Warjiyo mengungkap strategi yang dilakukan oleh bank sentral ini untuk menjaga stabilitas nilai tukar rupiah di tengah gejolak ekonomi global.\n\nStrategi pertama adalah dengan tetap memastikan ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/08/perry-warjiyo-2ab.jpg\" align=\"left\" border=\"0\" />Gubernur Bank Indonesia (BI) Perry Warjiyo mengungkap strategi yang dilakukan oleh bank sentral ini untuk menjaga stabilitas nilai tukar rupiah di tengah gejolak ekonomi global.\n\nStrategi pertama adalah dengan tetap memastikan ...",
      "date": "2023-05-08T14:04:13.000Z",
      "pubdate": "2023-05-08T14:04:13.000Z",
      "link": "https://www.antaranews.com/berita/3527544/bi-ungkap-strategi-menjaga-stabilitas-rupiah-di-tengah-gejolak-ekonomi"
    },
    {
      "title": "Abdul Hafiz raih emas dan Ndiken kantongi perunggu dari lempar lembing",
      "description": "Indonesia menambah pundi-pundi medali dari cabang olahraga atletik disiplin lempar lembing putra setelah Abdul Hafiz meraih emas dan Agustinus Abadi Ndiken menyumbang perunggu pada SEA Games XXXII/2023 Kamboja.\n\nKedua atlet ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/08/Lempar-Lembing-Emas-Sea-Games-080523-Adm-1.jpg\" align=\"left\" border=\"0\" />Indonesia menambah pundi-pundi medali dari cabang olahraga atletik disiplin lempar lembing putra setelah Abdul Hafiz meraih emas dan Agustinus Abadi Ndiken menyumbang perunggu pada SEA Games XXXII/2023 Kamboja.\n\nKedua atlet ...",
      "date": "2023-05-08T13:46:16.000Z",
      "pubdate": "2023-05-08T13:46:16.000Z",
      "link": "https://www.antaranews.com/berita/3527502/abdul-hafiz-raih-emas-dan-ndiken-kantongi-perunggu-dari-lempar-lembing"
    },
    {
      "title": "Menko Airlangga sebut 156 PSN telah selesai dibangun",
      "description": "Menteri Koordinator Bidang Perekonomian Airlangga Hartarto menyebutkan, sebanyak 156 Proyek Strategis Nasional (PSN) di seluruh Indonesia telah dirampungkan sejak 2016.\n\n&ldquo;PSN tersebut antara lain jalan tol dan kereta api. ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/08/publikasi_1683533183_6458ad7f27170.jpg\" align=\"left\" border=\"0\" />Menteri Koordinator Bidang Perekonomian Airlangga Hartarto menyebutkan, sebanyak 156 Proyek Strategis Nasional (PSN) di seluruh Indonesia telah dirampungkan sejak 2016.\n\n&ldquo;PSN tersebut antara lain jalan tol dan kereta api. ...",
      "date": "2023-05-08T12:43:47.000Z",
      "pubdate": "2023-05-08T12:43:47.000Z",
      "link": "https://ramadhan.antaranews.com/berita/3527364/menko-airlangga-sebut-156-psn-telah-selesai-dibangun"
    },
    {
      "title": "Menkeu minta darurat COVID jadi pijakan kembangkan layanan kesehatan",
      "description": "Menteri Keuangan (Menkeu) Sri Mulyani Indrawati meminta pengalaman selama fase darurat kesehatan akibat COVID-19 di Indonesia dapat dijadikan sebagai pengalaman dalam menggali ilmu pengetahuan untuk pengembangan layanan kesehatan ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/08/indrawati-1ab.jpg\" align=\"left\" border=\"0\" />Menteri Keuangan (Menkeu) Sri Mulyani Indrawati meminta pengalaman selama fase darurat kesehatan akibat COVID-19 di Indonesia dapat dijadikan sebagai pengalaman dalam menggali ilmu pengetahuan untuk pengembangan layanan kesehatan ...",
      "date": "2023-05-08T11:45:08.000Z",
      "pubdate": "2023-05-08T11:45:08.000Z",
      "link": "https://www.antaranews.com/berita/3527199/menkeu-minta-darurat-covid-jadi-pijakan-kembangkan-layanan-kesehatan"
    },
    {
      "title": "Tekad Indonesia dan ASEAN bawa perdamaian di Myanmar tidak surut",
      "description": "ANTARA - Presiden Joko Widodo, Senin (8/5), kembali menegaskan tekad Indonesia dan ASEAN dalam menyerukan perdamaian di Myanmar. Presiden Jokowi secara khusus meminta pihak-pihak terkait untuk menghentikan kekerasan di negara ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/SD_3.jpg\" align=\"left\" border=\"0\" />ANTARA - Presiden Joko Widodo, Senin (8/5), kembali menegaskan tekad Indonesia dan ASEAN dalam menyerukan perdamaian di Myanmar. Presiden Jokowi secara khusus meminta pihak-pihak terkait untuk menghentikan kekerasan di negara ...",
      "date": "2023-05-08T09:30:57.000Z",
      "pubdate": "2023-05-08T09:30:57.000Z",
      "link": "https://www.antaranews.com/video/3526794/tekad-indonesia-dan-asean-bawa-perdamaian-di-myanmar-tidak-surut"
    },
    {
      "title": "Presiden Joko Widodo sampaikan keterangan pers jelang KTT ke-42 ASEAN",
      "description": "Presiden Joko Widodo memberikan keterangan menjelang Konferensi Tingkat Tinggi (KTT) ke-42 ASEAN di Hotel Meurorah Komodo, Labuan Bajo, NTT, Senin (8/5/2023). Indonesia akan mengusung misi pemberantasan perdagangan manusia untuk ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/08/Preskon-Presiden-080523-Ak-3.jpg\" align=\"left\" border=\"0\" />Presiden Joko Widodo memberikan keterangan menjelang Konferensi Tingkat Tinggi (KTT) ke-42 ASEAN di Hotel Meurorah Komodo, Labuan Bajo, NTT, Senin (8/5/2023). Indonesia akan mengusung misi pemberantasan perdagangan manusia untuk ...",
      "date": "2023-05-08T08:45:07.000Z",
      "pubdate": "2023-05-08T08:45:07.000Z",
      "link": "https://www.antaranews.com/foto/3526695/presiden-joko-widodo-sampaikan-keterangan-pers-jelang-ktt-ke-42-asean"
    },
    {
      "title": "BMKG deteksi bibit siklon 91S & 91B, potensi hujan RI masih tinggi",
      "description": "Badan Meteorologi, Klimatologi, dan Geofisika (BMKG) mendeteksi kemunculan bibit siklon tropis 91S dan 91B di sekitar wilayah Indonesia yang berpotensi mempengaruhi cuaca di sejumlah wilayah dalam beberapa hari ke ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/08/IMG_20230508_160448_1.jpg\" align=\"left\" border=\"0\" />Badan Meteorologi, Klimatologi, dan Geofisika (BMKG) mendeteksi kemunculan bibit siklon tropis 91S dan 91B di sekitar wilayah Indonesia yang berpotensi mempengaruhi cuaca di sejumlah wilayah dalam beberapa hari ke ...",
      "date": "2023-05-08T08:20:55.000Z",
      "pubdate": "2023-05-08T08:20:55.000Z",
      "link": "https://www.antaranews.com/berita/3526629/bmkg-deteksi-bibit-siklon-91s-91b-potensi-hujan-ri-masih-tinggi"
    },
    {
      "title": "RI usung pembahasan pemberantasan perdagangan manusia di KTT ASEAN",
      "description": "Pemerintah RI mengusung pembahasan pemberantasan perdagangan manusia dalam Konferensi Tingkat Tinggi (KTT) Ke-42 ASEAN di Labuan Bajo, Manggarai Barat, Nusa Tenggara Timur, pada 9-11 Mei 2023.\n\nDalam keterangan pers di Hotel ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/08/Preskon-Presiden-080523-Ak-2.jpg\" align=\"left\" border=\"0\" />Pemerintah RI mengusung pembahasan pemberantasan perdagangan manusia dalam Konferensi Tingkat Tinggi (KTT) Ke-42 ASEAN di Labuan Bajo, Manggarai Barat, Nusa Tenggara Timur, pada 9-11 Mei 2023.\n\nDalam keterangan pers di Hotel ...",
      "date": "2023-05-08T07:13:30.000Z",
      "pubdate": "2023-05-08T07:13:30.000Z",
      "link": "https://www.antaranews.com/berita/3526449/ri-usung-pembahasan-pemberantasan-perdagangan-manusia-di-ktt-asean"
    },
    {
      "title": "Mahfud MD pastikan keamanan KTT ASEAN sudah baik di semua lini",
      "description": "Menteri Koordinator Bidang Politik, Hukum, dan Keamanan (Menkopolhukam) Mahfud MD memastikan bahwa pengamanan untuk Konferensi Tingkat Tinggi (KTT) ASEAN di Labuan Bajo, Nusa Tenggara Timur (NTT) sudah baik di semua ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/08/WhatsApp-Image-2023-05-08-at-14.23.47.jpg\" align=\"left\" border=\"0\" />Menteri Koordinator Bidang Politik, Hukum, dan Keamanan (Menkopolhukam) Mahfud MD memastikan bahwa pengamanan untuk Konferensi Tingkat Tinggi (KTT) ASEAN di Labuan Bajo, Nusa Tenggara Timur (NTT) sudah baik di semua ...",
      "date": "2023-05-08T06:57:49.000Z",
      "pubdate": "2023-05-08T06:57:49.000Z",
      "link": "https://www.antaranews.com/berita/3526413/mahfud-md-pastikan-keamanan-ktt-asean-sudah-baik-di-semua-lini"
    },
    {
      "title": "Klasemen medali SEA Games: Tambah emas, Indonesia kembali urutan kedua",
      "description": "Indonesia kembali ke urutan kedua klasemen sementara perolehan medali SEA Games 2023 setelah berhasil menambah empat medali emas, Senin siang, sekaligus menggeser Thailand ke posisi ketiga.\n\nTiga medali emas dipersembahkan ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/08/60c621df-fb8c-4ef9-889d-72fbb5531892.jpg\" align=\"left\" border=\"0\" />Indonesia kembali ke urutan kedua klasemen sementara perolehan medali SEA Games 2023 setelah berhasil menambah empat medali emas, Senin siang, sekaligus menggeser Thailand ke posisi ketiga.\n\nTiga medali emas dipersembahkan ...",
      "date": "2023-05-08T06:49:30.000Z",
      "pubdate": "2023-05-08T06:49:30.000Z",
      "link": "https://www.antaranews.com/berita/3526398/klasemen-medali-sea-games-tambah-emas-indonesia-kembali-urutan-kedua"
    },
    {
      "title": "Pebalap sepeda Dara Latifah debut manis raih emas kedua SEA Games 2023",
      "description": "Pebalap sepeda putri Indonesia Dara Latifah debut manis dengan meraih medali emas kedua pada SEA Games XXXII/2023 Kamboja.\n\nKali ini, atlet yang lahir pada 18 April 2003 itu menjadi yang terbaik pada nomor Cross Country ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/08/8C4855DC-97B9-4799-81C0-9D64B36253C9.jpg\" align=\"left\" border=\"0\" />Pebalap sepeda putri Indonesia Dara Latifah debut manis dengan meraih medali emas kedua pada SEA Games XXXII/2023 Kamboja.\n\nKali ini, atlet yang lahir pada 18 April 2003 itu menjadi yang terbaik pada nomor Cross Country ...",
      "date": "2023-05-08T06:45:19.000Z",
      "pubdate": "2023-05-08T06:45:19.000Z",
      "link": "https://www.antaranews.com/berita/3526389/pebalap-sepeda-dara-latifah-debut-manis-raih-emas-kedua-sea-games-2023"
    },
    {
      "title": "ASCC 2023 sepakati empat komitmen untuk dibahas di KTT ASEAN",
      "description": "Sidang Dewan Menteri Pilar Sosial Budaya ASEAN ke-29 (The 29th ASEAN Socio-Cultural Community/ASCC) 2023 menyepakati empat komitmen yang selanjutnya akan dibahas pada Konferensi Tingkat Tinggi (KTT)&nbsp; ke-42 ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/08/IMG-20230508-WA0013_4.jpg\" align=\"left\" border=\"0\" />Sidang Dewan Menteri Pilar Sosial Budaya ASEAN ke-29 (The 29th ASEAN Socio-Cultural Community/ASCC) 2023 menyepakati empat komitmen yang selanjutnya akan dibahas pada Konferensi Tingkat Tinggi (KTT)&nbsp; ke-42 ...",
      "date": "2023-05-08T06:11:53.000Z",
      "pubdate": "2023-05-08T06:11:53.000Z",
      "link": "https://www.antaranews.com/berita/3526314/ascc-2023-sepakati-empat-komitmen-untuk-dibahas-di-ktt-asean"
    },
    {
      "title": "BI perkirakan transaksi uang elektronik capai Rp495 triliun pada 2023",
      "description": "Gubernur Bank Indonesia (BI) Perry Warjiyo memperkirakan nilai transaksi uang elektronik pada 2023 tumbuh pesat mencapai Rp495 triliun, didorong oleh akselerasi ekonomi keuangan digital Indonesia.\n\n&quot;Uang elektronik tahun ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/08/Festival-Ekonomi-Keuangan-Digital-Indonesia-080523-hma-2.jpg\" align=\"left\" border=\"0\" />Gubernur Bank Indonesia (BI) Perry Warjiyo memperkirakan nilai transaksi uang elektronik pada 2023 tumbuh pesat mencapai Rp495 triliun, didorong oleh akselerasi ekonomi keuangan digital Indonesia.\n\n&quot;Uang elektronik tahun ...",
      "date": "2023-05-08T05:58:24.000Z",
      "pubdate": "2023-05-08T05:58:24.000Z",
      "link": "https://www.antaranews.com/berita/3526290/bi-perkirakan-transaksi-uang-elektronik-capai-rp495-triliun-pada-2023"
    },
    {
      "title": "Menteri KKP tegaskan kuota penangkapan ikan untuk cegah praktik ilegal",
      "description": "Menteri Kelautan dan Perikanan Sakti Wahyu Trenggono menegaskan kebijakan penangkapan ikan terukur berbasis kuota untuk mencegah praktik ilegal, tidak diatur, dan tidak terlaporkan (illegal unreported and unregulated ...",
      "summary": "<img style=\"margin-right: 10px;max-width: 200px;\" src=\"https://img.antaranews.com/cache/800x533/2023/05/08/IMG_20230508_101742_1.jpg\" align=\"left\" border=\"0\" />Menteri Kelautan dan Perikanan Sakti Wahyu Trenggono menegaskan kebijakan penangkapan ikan terukur berbasis kuota untuk mencegah praktik ilegal, tidak diatur, dan tidak terlaporkan (illegal unreported and unregulated ...",
      "date": "2023-05-08T05:56:04.000Z",
      "pubdate": "2023-05-08T05:56:04.000Z",
      "link": "https://www.antaranews.com/berita/3526284/menteri-kkp-tegaskan-kuota-penangkapan-ikan-untuk-cegah-praktik-ilegal"
    }
  ],
  popularCoins: [
    {
      id: 1,
      name: 'Bitcoin',
      shortName: 'BTC',
      marketCap: '129,820,932',
      volume: '25,111,773',
      h: '2.50',
      image: '/assets/images/bitcoin.svg',
      color: orange[600],
    },
    {
      id: 2,
      name: 'Ethereum',
      shortName: 'ETH',
      marketCap: '24,909,820',
      volume: '12,344,434',
      h: '0.45',
      image: '/assets/images/etherium.svg',
      color: 'black',
    },
    {
      id: 3,
      name: 'Litecoin',
      shortName: 'LTC',
      marketCap: '137,334,223',
      volume: '43,434,213',
      h: '3.43',
      image: '/assets/images/litcoin.svg',
      color: blue[400],
    },
    {
      id: 4,
      name: 'Monero',
      shortName: 'XMR',
      marketCap: '21,445,237',
      volume: '32,324,655',
      h: '0.93',
      image: '/assets/images/bitcoin.svg',
      color: orange[500],
    },
    {
      id: 5,
      name: 'Dashcoin',
      shortName: 'DASH',
      marketCap: '124,674,765',
      volume: '94,342,323',
      h: '.30',
      image: '/assets/images/bitcoin.svg',
      color: blue[600],
    },
  ],
  totalBalanceData: {
    balance: '33692.00',
    coins: [
      {id: 32423, name: 'Bitcoin', value: 9.654},
      {id: 3333, name: 'Monero', value: 76.184},
      {id: 44334, name: 'Ripple', value: 1567.5},
      {id: 54323, name: 'Litecoin', value: 56.78},
    ],
  },
  btcChartData: [
    {
      id: 1001,
      name: 'GBP',
      value: 302,
      color: '#4299E1',
    },
    {
      id: 1002,
      name: 'USD',
      value: 450,
      color: '#E53E3E',
    },
    {
      id: 1003,
      name: 'CNY',
      value: 274,
      color: '#38B2AC',
    },
    {
      id: 1004,
      name: 'EUR',
      value: 218,
      color: '#4C51BF',
    },
  ],
};
export default cryptoData;
